export const ChangesHistoryColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Вид услуг',
        key: 'type',
    },
    {
        name: 'Номер',
        key: 'clientId',
    },
    {
        name: 'Действие',
        key: 'actionName',
    },
    {
        name: 'Старое значение',
        key: 'old_value',
    },
    {
        name: 'Новое значение',
        key: 'new_value',
    },
    {
        name: 'Доп. услуги',
        key: 'a_s',
    },
    {
        name: 'Инициатор',
        key: 'email',
    },
    {
        name: 'Дата',
        key: 'createdAt',
    },
]
